import React, {useState} from 'react';
import { CardBody,  Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";
import { useForm } from "react-hook-form";
import Switch from "react-bootstrap-switch";
import SelectGeneric from "../../../components/select/selectGeneric";
import {harborProvider} from "../../../providers/harborProvider";

export default function XailingRoutFilters(props) {
	const [status, setStatus] = useState(null);
	const [harborFromId, setHarborFromId] = useState(null);
	const [harborToId, setHarborToId] = useState(null);

	const {register, handleSubmit, reset} = useForm();

	const onSubmit = (data, _) => {
		const dataFilter = {
			code  : data.code,
		};

		if (status !== null)
			dataFilter.status = status;

		if (harborFromId !== undefined && harborFromId !== null && harborFromId !== '')
			dataFilter.fromHarbor = { id : harborFromId };

		if (harborToId !== undefined && harborToId !== null && harborToId !== '')
			dataFilter.toHarbor = { id : harborToId };

		props.refreshFiltered(dataFilter);
	};

	const cleanFields = () => {
		setHarborFromId(null);
		setHarborToId(null);
		setStatus(null);
		reset();
	}

	const onStatusChange = () => {
		if (status === null)
			setStatus(true);
		else
			setStatus(!status);
	}

	return (
		<Form onSubmit={handleSubmit(onSubmit)}>
			<CardBody className="">
				<Row>
					<Col md="3">
						<FormGroup>
							<Label>Codigo</Label>
							<Input type="text" name="code"
							       placeholder="Búsqueda por código"
							       innerRef={register}
							/>
						</FormGroup>
					</Col>
					<Col md="3">
						<FormGroup>
							<Label>Activo</Label>
							<br/>
							<Switch animate={true} offText={"No"} onText={"Si"}
							        value={status}
							        innerRef={register}
							        onChange={onStatusChange}
							/>
						</FormGroup>
					</Col>
					<Col md="3">
						<FormGroup>
							<Label>Puerto origen</Label>
							<SelectGeneric
								initialValue={ harborFromId }
								setExternalValue={ value => setHarborFromId( value ) }
								isDisabled={ false }
								provider = { harborProvider }
							/>
						</FormGroup>
					</Col>
					<Col md="3">
						<FormGroup>
							<Label>Puerto destino</Label>
							<SelectGeneric
								initialValue={ harborToId }
								setExternalValue={ value => setHarborToId( value ) }
								isDisabled={ false }
								provider = { harborProvider }
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md="12" className="d-flex justify-content-center">
						<div className="float-right">
							<ButtonSearch/>
							<ButtonClean onClick={() => cleanFields()}/>
						</div>
					</Col>
				</Row>
			</CardBody>
		</Form>
	)
}